<template>
     <div class="cart_wrap">
        <div class="container">
            <template v-if="get_sub_total==0">
               <div class="cart_empty">
                    <img src="@/assets/emptycart.svg" alt="">
                     <p>{{get_local_string.string_111}}</p>
                     <b-button tag="router-link" to="/meny" type="is-success">{{get_local_string.string_106}}</b-button>
               </div>
            </template>
            <template v-else-if="all_data_cart.status==402">
                <div class="colsed_wrap">
                    <img src="@/assets/closed.png" alt="">
                </div>
            </template>
            <template v-else>
               <div class="row">
                <div class="col-md-6">
                    <div class="text_panel_up">
                        <h2>{{get_local_string.string_6}}</h2>
                    </div>
                    <ul uk-accordion>
                        <!-- prod list -->
                        <li>
                            <!-- {{all_data_cart}} -->
                            <a class="uk-accordion-title" href="#">
                                <div class="panelBg cart_panel">
                                    <span class="text_panel"><span><i class="fas fa-shopping-basket"></i></span> {{get_local_string.string_7}}</span>
                                    <span class="total_price"><strong>{{get_final_item_total}}{{get_setting_app.payment.currency}}</strong>
                                        <del class="del_dis" v-if="get_coupon_object.is_apply==1" > <strong class="pr-0">{{get_sub_total}}{{get_setting_app.payment.currency}}</strong></del>
                                    </span>
                                </div>
                            </a>
                            <div class="uk-accordion-content">
                                 <div class="list_added_item" >
                                <span class="single_side"  v-for="(sideitem , index) in get_data_cart" :key="sideitem.item_id">
                                    <div class="move_left move_left_cart" @click.self="show_option($event)" :price_data="sideitem.price" :qty="sideitem.quantity">
                                        <img @click="show_option2($event)" v-if="sideitem" :src="sideitem.image" alt="">
                                        <span @click="show_option2($event)" class="name_side">
                                        {{sideitem.quantity}} x 
                                        <!-- added in tilbud -->
                                        <template v-if="sideitem.data.length==1">
                                            <span v-for="tilbud_item in sideitem.data" :key="tilbud_item.id">
                                            {{tilbud_item.name}}
                                        </span>
                                        </template>
                                        <template v-else>
                                            <div class="flex_tilbud_side">
                                                <span v-for="tilbud_item in sideitem.data" :key="tilbud_item.id">
                                            {{tilbud_item.name}}
                                        </span>
                                            </div>
                                        </template>
                                         <br>
                                        {{sideitem.dough}}
                                        <br>
                                        {{sideitem.size}} 
                                    </span>
                                    <span @click="show_option2($event)" class="price_side"> <span :class="[(get_coupon_object.is_apply==1 ? 'red_price_side' : '')]" >{{sideitem.final_price}}{{get_setting_app.payment.currency}}</span> <del  v-show="get_coupon_object.is_apply==1">{{sideitem.price}}{{get_setting_app.payment.currency}} </del> </span>
                                    <aside>
                                        <b-field class="d-inline-block">
                                    <b-select v-model="sideitem.quantity" @input.native="updateItem(sideitem , $event)" class="qty_side" name="" id="" >
                                        <template v-for="qty in sideitem.quantity+3" >
                                                <option :value="qty" :key="qty.id">{{qty}}</option>
                                            </template>
                                    </b-select>
                                </b-field>
                                <b-button type="is-danger" :id="`del-${index+1}`"  @click="delteItem(sideitem , index+1)" class="remove_item"
                                    icon-right="delete" />
                                        <!-- <button ><i class="fas fa-trash-alt"></i></button> -->
                                    </aside>
                                    </div>
                                
                                </span>
                                <!--  -->
                                    </div>   
                            </div>
                        </li>
                        <!-- time date -->
                        <li v-show="all_data_cart.active_order_time==1">
                            <a class="uk-accordion-title" href="#">
                                <div class="panelBg">
                                    <span class="text_panel"><span>
                                        <i class="fas fa-clock"></i>
                                    </span>{{get_local_string.string_8}}
                                    </span>
                                    <span class="change_span_time">{{get_local_string.string_9}}</span>
                                </div> </a>
                            <div class="uk-accordion-content">
                                <b-tabs  v-model="activeTab"  type="is-success" @click.native="changeTabFunc(activeTab)">
                                  <!--  -->
                                  <template v-if="all_data_cart.defult_time == true">
                                         <b-tab-item class="tab_first" :label="get_local_string.string_12" icon="calendar-range">
                                     <!-- takeaway and levering  -->
                                      <p class="text-muted">{{get_local_string.string_10}}</p>
                                      <p class="text-muted">{{get_local_string.string_11}}</p>
                                </b-tab-item>
                                <b-tab-item  label="Senere tidspunkt" icon="calendar-refresh-outline">
                                <!-- <a href="#modal-dates" uk-toggle>Open</a> -->
                                <div  :class="['selected_pre_date', (pre_full_date=='' ? 'empty_date' : '')]"  @click="openModal_hour()">
                                  <template v-if="pre_full_date==''">
                                    {{get_local_string.string_13}}
                                  </template>
                                  <template v-else>
                                      <div class="sm_wrapp">
                                           <div class="left_date">
                                        <span class="day_text">{{default_clock.day}}</span>
                                        <span class="day_date">{{default_clock.date}}</span>
                                    </div>
                                    <div class="right_date">
                                        <span>{{default_clock.time}}</span>
                                    </div>
                                      </div>
                                  </template>
                                  
                                    <i class="fas fa-edit icons_edit_date"></i>
                                </div>
                                </b-tab-item>
                                    </template>
                                    <template v-else-if="all_data_cart.defult_time == false">
                                        <p>Null Value  from Default</p>
                                    </template>
                                    <!-- if date default -->
                                    <template v-else>
                                         <b-tab-item :visible="false"  :label="get_local_string.string_12" icon="calendar-range">
                                          <span class="asap">{{get_local_string.string_12}} </span>
                                          <!-- <span>Takeaway (ca 10-20min)</span>
                                          <span>Utkjøring (ca 30-60min)</span> -->
                                           <span> {{get_local_string.string_10}}</span>
                                      <span>{{get_local_string.string_11}}</span>
                                          
                                         </b-tab-item>
                                <b-tab-item  label="Senere tidspunkt" icon="calendar-refresh-outline">
                                <!-- <a href="#modal-dates" uk-toggle>Open</a> -->
                                <div class="selected_pre_date"  @click="openModal_hour()">
                                    <div class="sm_wrapp">
                                         <div class="left_date">
                                        <span class="day_text">{{default_clock.day}}</span>
                                        <span class="day_date">{{default_clock.date}}</span>
                                    </div>
                                    <div class="right_date">
                                        <span>{{default_clock.time}}</span>
                                    </div>
                                    </div>
                                    <i class="fas fa-edit icons_edit_date"></i>
                                </div>
                                </b-tab-item>
                                    </template>
                                  <!--  -->
                                  </b-tabs>
                               <!-- This is the modal -->
                                <div id="modal-dates" uk-modal>
                                     <button class="uk-modal-close-default" type="button" uk-close></button>
                                    <div class="uk-modal-dialog uk-modal-body">
                                        <h2 class="dates_title">{{get_local_string.string_13}}</h2>
                                        <h3 class="sub_title">{{get_local_string.string_14}}</h3>
                                        <div class="felx_dates">
                                            <template v-for="(singel_date,index) in all_data_cart.date_list">
                                                <a :key="singel_date.id"  :class="['single_date', (index === 0 ? 'active' : '')]" @click="get_date_click(singel_date, index)" :id='`date_${index}`'>
                                                <span class="date_name">{{singel_date.text}}</span>
                                                <span class="date_num">{{singel_date.day}}</span>
                                            </a>
                                            </template>
                                            
                                        </div>
                                        <!-- get_pre_days -->
                                        <h3 class="sub_title">{{get_local_string.string_9}}</h3>
                                        <template v-if="Object.keys(getDayPre).length>0">
                                            <div class="flex_hour">
                                            <template v-for="(hour,index) in  getDayPre">
                                            <a :key="hour.id" :class="['uk-animation-slide-top-medium', (index === 0 ? 'active' : '')]" @click="get_hour_click(hour,index)" :id='`hour_${index}`'>
                                                <span class="hour_num">{{hour.time}}</span>
                                            </a>
                                            </template>                                  
                                        </div>
                                        <b-button type="is-dark" icon-left="sort-clock-ascending" class="load-more" @click.native="show_more_hour()">
                                                {{get_local_string.string_15}}
                                        </b-button>
                                        </template>
                                        <template v-else>
                                            <p class="color-white"> {{get_local_string.string_16}}</p>
                                        </template>
                                        
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- delvery -->
                            <li :class="[(get_setting_app.delivery.open_delivery==0 ? 'not_open_li' : 'uk-open')]">
                            <a class="uk-accordion-title" href="#">
                                <template v-if="get_setting_app.delivery.open_delivery==0">
                                    <div class="panelBg">
                                    <span class="text_panel"><span>
                                        <i class="fas fa-truck"></i>
                                    </span>{{get_local_string.string_17}}
                                    </span>
                                    <span class="change_span_time">{{get_local_string.string_127}}</span>
                                     </div>
                                    </template>
                                    <template v-else>
                                        <div class="panelBg">
                                    <span class="text_panel"><span>
                                        <i class="fas fa-truck"></i>
                                    </span>   {{get_local_string.string_17}}</span>
                                   <div class="plus_devery_price"> <strong>+{{plus_price_delevery}}</strong> {{get_setting_app.payment.currency}}</div>
                                </div>
                                    </template>
                                 </a>
                            <div class="uk-accordion-content">
                            <div class="flex_delevey">
                                <label v-if="get_setting_app.delivery.open_takeaway==1"  @click="get_takeaway()" class="option_levering takeaway">
                                  <b-radio v-model="levering_method"  name="levering_method" native-value="takeaway"> </b-radio>
                                  <div>
                                 <img src="~@/assets/icons/tk_fil.svg" alt="">
                                <span class="levering_title" >{{get_local_string.string_18}}</span>
                                  </div>
                                </label>
                                
                                <label v-if="get_setting_app.delivery.open_delivery==1" @click="get_delevery()" class="option_levering delevery">
                                    <b-radio  v-model="levering_method" name="levering_method" native-value="delevery"> </b-radio>
                                    <img src="~@/assets/icons/del_fil.svg" alt="">
                                    <span class="levering_title">{{get_local_string.string_19}}</span>
                                </label>
                            </div>
                                <div class="is_choose_delvery">
                                    <hr class="mt-1 ">
                                    <div class="text-left ml-3 flex_list_add"> 
                                    <h2 class="address_title">{{get_local_string.string_20}}</h2>
                                    <b-button class="mb-5 addbtnaddress" @click="show_modal_map()" type="is-success" size="is-small"
                                    > <i class="fas fa-map-marker-alt newIcons"></i> {{get_local_string.string_21}} </b-button>
                                    </div>
                                    <template v-if="user.addressList.length>0">
                                    <div class="address_list">
                                        <!-- {{user.addressList}} -->
                                            <b-field v-for="address in  user.addressList" :key="address.id" class="myaddressRadio" :id="'id-'+address.id">
                                                <b-radio v-model="radio_address"
                                                :radio_min="address.min_order"
                                                :disabled="(address.min_order >get_sub_total? true : false)"
                                                 @change.native="chnageAddress(address.id ,address.price , address.min_order)"
                                                    :native-value="address.id"
                                                    type="is-success">
                                                    <span class="adress_text">{{address.address_text}}
                                                    </span>
                                                    <!-- <span class="distance"></span> -->
                                                    <span class="right_address">
                                                        <span class="adress_price">{{address.price}}{{get_setting_app.payment.currency}}</span>
                                                        <span class="Kms">{{address.distance}} {{get_local_string.string_22}}</span>
                                                    </span>
                                                    <span class="note">{{address.min_order_alert}}</span>
                                                </b-radio>
                                                <b-button class="removeAddress" @click="removeAddress(address.id)" size="is-small" type="is-danger"><i class="fas fa-trash-alt"></i></b-button>
                                            </b-field>
                                        </div>
                                    </template>
                                    <template v-else>
                                    <div class="noAddress_wrap">
                                        <img src="@/assets/no_address.svg" alt="">
                                        <p> {{get_local_string.string_23}}</p>
                                    </div>
                                    </template> 
                                    </div>
                                <!-- delevery map -->
                            </div>
                        </li>
                         <!-- notes -->
                          <li>
                            <a class="uk-accordion-title" href="#">
                                <div class="panelBg">
                                    <span class="text_panel"><span>
                                        <i class="fas fa-comment-alt"></i>
                                    </span> {{get_local_string.string_24}}</span>
                                </div>
                            </a>
                            <div class="uk-accordion-content">
                                <div class="comment">
                                      <b-field :label="get_local_string.string_24"
                                    :label-position="labelPosition">
                                    <b-input maxlength="200" v-model="order_details.note" type="textarea"></b-input>
                                </b-field>
                                </div>
                               
                            </div>
                        </li>
                        
                    </ul>
                </div>
                <div :class="['col-md-6', (active_alert_wraning === true ? 'col_warning_class' : '')]"  >
                    <b-notification
                            v-model="active_alert_wraning"
                            type="is-warning"
                            has-icon
                            role="alert"
                            :closable="false">
                           {{get_local_string.string_25}}
                            <br>
                            <strong>  <span>{{default_clock.day}}</span> <span>{{default_clock.date}}</span> <span>{{default_clock.time}}</span></strong>      
                        </b-notification>
                   
                          <!-- coupon -->
                         <div  class="uk-alert dis_wrap" uk-alert>
                        <b-field type="is-success">
                            <b-input class="input_code" :disabled="get_coupon_object.is_apply==1"   placeholder="Coupon Code .."  v-model="couopn_input"
                                icon="tag-heart" >
                            </b-input>
                            <p class="control">
                                <b-button v-if="get_coupon_object.is_apply!=1" @click.prevent="apply_coupon_code()" :label="get_local_string.string_27" type="is-success" />
                                <b-button class="remove_code" v-if="get_coupon_object.is_apply==1" @click.prevent="remove_coupon_code()" type="is-danger">
                                        <ion-icon name="close-sharp"></ion-icon>
                                    </b-button>   
                            </p>
                        </b-field>
                        <a v-show="get_coupon_object.is_apply==1" class="span_dis" href="#discount" uk-toggle><span class="mdi mdi-tag-heart"></span>
                        {{get_local_string.string_26}}
                        </a>
                      
                         </div>
                   <!-- end coupon -->

                    <div class="box_pay">
                        <div class="title_Pay_up">
                            {{get_local_string.string_28}}
                        </div>
                        <div class="price_will_payed">
                              <b-tooltip type="is-dark" size="is-small" position="is-bottom" multilined>
                          <span> {{get_local_string.string_29}} 
                                    <strong class="grand_total_with_delevery">{{get_grand_total}}{{get_setting_app.payment.currency}} </strong>
                                    <del class="del_dis" v-if="get_coupon_object.is_apply==1" > <strong>{{get_before_dicount}}</strong>{{get_setting_app.payment.currency}}</del>
                            </span>
                            <template v-slot:content>
                                        <div class="flex_tooltip">
                                            <span>{{get_local_string.string_7}} : <b>{{get_grand_total}} {{get_setting_app.payment.currency}}</b>
                                         </span>
                                          <span>{{get_local_string.string_17}}  : <b> +  {{plus_price_delevery}} {{get_setting_app.payment.currency}}</b>
                                         </span>
                                        </div>
                                    </template>
                                </b-tooltip>    
                        </div>
                        <div class="secure_pay">
                            <i class="fal fa-lock-alt"></i> <span>{{get_local_string.string_30}}</span>
                        </div>
                        <div class="payement_links">
                             <b-button :disabled="disabled_pay_button" v-if="get_setting_app.payment.active_cash==1" type="is-dark" class="w-100 b-btn-load" @click="pay_cash()" :loading="payemnt_load_1">
                              <span class="payemnt_btn shopping_more"><img src="https://cdn.iconscout.com/icon/free/png-256/cash-payment-1443455-1220293.png" alt=""> {{get_local_string.string_31}}</span>
                             </b-button>
                           <b-button :disabled="disabled_pay_button" v-if="get_setting_app.payment.active_vipps==1" @click="pay_vipps()" :loading="payemnt_load_2" class="w-100 vipps"></b-button> 
                            
                            <b-button :disabled="disabled_pay_button" v-if="get_setting_app.payment.active_stripe==1" @click="open_modal_stripe()" :loading="payemnt_load_3" class="w-100 stripe">
                            {{get_local_string.string_32}} <i class="fab fa-cc-stripe"></i> 
                            </b-button>
                             <b-button :disabled="disabled_pay_button" v-if="get_setting_app.payment.active_sumup==1" @click="open_modal_sumup()" :loading="payemnt_load_4" class="w-100 sumup">
                             {{get_local_string.string_32}} <img src="https://www.prestigechauffeuralgarve.com/upload/sumup-logo.png" alt="">
                            </b-button> 
                        </div>
                    </div>
                             <!-- This is the modal -->
                        <div id="modal-stripe" class="uk-modal-container" uk-modal>
                             <button class="uk-modal-close-default" type="button" uk-close></button>
                            <div class="uk-modal-dialog uk-modal-body">
                                <h2 class="dates_title">{{get_local_string.string_33}} </h2>
                                             <div class="row">
                                                  <div class="col-xl-6 col-lg-6 mb-4 add_card_wrap uk-animation-slide-bottom">
                                                       <b-field>
                                                            <b-radio 
                                                    type="is-success">
                                                  <div class="card_front" @click="open_modal_add_card()">
                                                         
                                              <div class="card-item__cover"><img :src="`https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/16.jpeg`" class="card-item__bg"></div>
                                             <div class="card_view">
                                              <div class="card-item__top"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png" class="card-item__chip">
                                               <div class="card-item__type"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/visa.png" alt="" class="card-item__typeImg d-none">
                                            </div>
                                              </div>
                                              <!-- end top -->
                                              <div class="card-item__number">
                                                 {{get_local_string.string_34}}
                                              </div>
                                              <!-- end cart num -->
                                              <div class="card-item__content d-none">
                                                <label for="cardName" class="card-item__info"><div class="card-item__holder">
                                                    {{get_local_string.string_36}}
                                                    </div> <div class="card-item__name">{{get_local_string.string_37}}</div></label> 
                                              
                                              <div class="card-item__date"><label for="cardMonth" class="card-item__dateTitle w-100 d-block">{{get_local_string.string_38}}</label> <label for="cardMonth" class="card-item__dateItem"><span>MM</span></label>
                                           /
                                         <label for="cardYear" class="card-item__dateItem"><span>YY</span></label>
                                            </div>
                                            </div>
                                          </div>
                                                    </div>
                                                            </b-radio>
                                                    </b-field>
                                            </div>
                                            <b-field  class="col-xl-6 col-lg-6 mb-4 uk-animation-slide-bottom" v-for="(card,index) in  get_stripe_card_list.data" :key="card.id">
                                                <b-radio v-model="stripe_card" @change.native="changecard_stripe(card.id)" @focus="changecard_stripe(card.id)"
                                                    :native-value="card.id"
                                                    type="is-primary">
                                                     <div class="card_front">
                                                         
                                              <div class="card-item__cover"><img :src="`https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/${random_bg}.jpeg`" class="card-item__bg"></div>
                                             <div class="card_view">
                                              <div class="card-item__top"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png" class="card-item__chip">
                                               <div class="card-item__type"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/visa.png" alt="" class="card-item__typeImg">
                                            </div>
                                              </div>
                                              <!-- end top -->
                                              <div class="card-item__number">
                                                 <span>****</span>
                                                 <span>****</span>
                                                 <span>****</span>
                                                 <span>{{card.last4}}</span>
                                              </div>
                                              <!-- end cart num -->
                                              <div class="card-item__content">
                                                <label for="cardName" class="card-item__info"><div class="card-item__holder">{{get_local_string.string_34}}</div> <div class="card-item__name">{{
                                                    card.customer}}</div></label> 
                                              
                                              <div class="card-item__date"><label for="cardMonth" class="card-item__dateTitle w-100 d-block">{{get_local_string.string_38}}</label> <label for="cardMonth" class="card-item__dateItem"><span>{{card.exp_month}}</span></label>
                                           /
                                       <label for="cardYear" class="card-item__dateItem"><span>{{card.exp_year}}</span></label>
                                            </div>
                                            </div>
                                          </div>
                                                     </div>
                                           <b-button @click="remove_stripe_card(card.id,index)" :loading="delete_stripe_card_load && delete_card_index==index" class="removeCard" size="is-small" type="is-danger"><i class="fas fa-trash-alt"></i></b-button>
                                                </b-radio>
                                            </b-field>
                                          </div>
                                           <b-button @click="pay_stripe()" :disabled="checkout_stripe" :loading="stripe_load"  class="check_out_sticky" type="is-primary" expanded>
                                                {{get_local_string.string_39}} <i class="fab fa-cc-stripe"></i>
                                           </b-button>
                            </div>
                          
                        </div>   
                        <!-- modal sumup -->
                             <!-- This is the modal -->
                        <div id="modal-sumup" class="uk-modal-container" uk-modal>
                             <button class="uk-modal-close-default" type="button" uk-close></button>
                            <div class="uk-modal-dialog uk-modal-body">
                                <h2 class="dates_title">{{get_local_string.string_40}} </h2>
                                             <div class="row">
                                                  <div class="col-xl-6 col-lg-6 mb-4 add_card_wrap uk-animation-slide-bottom">
                                                       <b-field>
                                                            <b-radio 
                                                    type="is-success">
                                                  <div class="card_front" @click="open_modal_add_card_sumup()">
                                                         
                                              <div class="card-item__cover"><img :src="`https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/16.jpeg`" class="card-item__bg"></div>
                                             <div class="card_view">
                                              <div class="card-item__top"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png" class="card-item__chip">
                                               <div class="card-item__type"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/visa.png" alt="" class="card-item__typeImg d-none">
                                            </div>
                                              </div>
                                              <!-- end top -->
                                              <div class="card-item__number">
                                                 {{get_local_string.string_34}}
                                              </div>
                                              <!-- end cart num -->
                                              <div class="card-item__content d-none">
                                                <label for="cardName" class="card-item__info"><div class="card-item__holder">{{get_local_string.string_34}}</div> <div class="card-item__name">{{get_local_string.string_37}}</div></label> 
                                              
                                              <div class="card-item__date"><label for="cardMonth" class="card-item__dateTitle w-100 d-block">{{get_local_string.string_38}}</label> <label for="cardMonth" class="card-item__dateItem"><span>MM</span></label>
                                           /
                                         <label for="cardYear" class="card-item__dateItem"><span>YY</span></label>
                                            </div>
                                            </div>
                                          </div>
                                                    </div>
                                                            </b-radio>
                                                    </b-field>
                                            </div>
                                            <template  v-for="(card,index) in  get_sumup_card_list.data">
                                                 <b-field  class="col-xl-6 col-lg-6 mb-4 uk-animation-slide-bottom" 
                                             :key="card.token"  v-if="card.active" >
                                                <b-radio v-model="sumup_card" @change.native="changecard_sumup(card.token)" @focus="changecard_sumup(card.token)"
                                                    :native-value="card.token"
                                                    type="is-success">
                                                     <div class="card_front">
                                                         
                                              <div class="card-item__cover"><img :src="`https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/${random_bg}.jpeg`" class="card-item__bg"></div>
                                             <div class="card_view">
                                              <div class="card-item__top"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png" class="card-item__chip">
                                               <div class="card-item__type"><img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/visa.png" alt="" class="card-item__typeImg">
                                            </div>
                                              </div>
                                              <!-- end top -->
                                              <div class="card-item__number">
                                                 <span>****</span>
                                                 <span>****</span>
                                                 <span>****</span>
                                                 <span>{{card.card.last_4_digits}}</span>
                                              </div>
                                              <!-- end cart num -->
                                              <div class="card-item__content d-none">
                                                <label for="cardName" class="card-item__info"><div class="card-item__holder">{{get_local_string.string_34}}</div> <div class="card-item__name"></div></label> 
                                              
                                              <div class="card-item__date"><label for="cardMonth" class="card-item__dateTitle w-100 d-block">{{get_local_string.string_38}}</label> <label for="cardMonth" class="card-item__dateItem"><span></span></label>
                                           /
                                          <label for="cardYear" class="card-item__dateItem"><span></span></label>
                                            </div>
                                            </div>
                                          </div>
                                                     </div>
                                           <b-button @click="remove_sumup_card(card.token,index)" :loading="delete_sumup_card_load && delete_card_index==index" class="removeCard" size="is-small" type="is-danger"><i class="fas fa-trash-alt"></i></b-button>
                                                </b-radio>
                                            </b-field>
                                            </template>
                                           
                                          </div>
                                           <b-button @click="pay_sumup()" :disabled="checkout_sumup" :loading="sumup_load"  class="check_out_sticky sumup"  expanded>
                                                {{get_local_string.string_39}} <img src="https://www.prestigechauffeuralgarve.com/upload/sumup-logo.png" alt="">
                                           </b-button>
                            </div>
                          
                        </div>   
                        <!-- add new cart stripe -->
                        <div id="modal-add-card" uk-modal="stack:true">
                            <div class="uk-modal-dialog uk-modal-body">
                                <button class="uk-modal-close-default" type="button" uk-close></button>
                                <h2 class="uk-modal-title">{{get_local_string.string_34}}</h2>
                                        <!-- :trans="translations" -->
                                        <v-credit-card @change="creditInfoChanged" ref="vcard"  />
                                        <div class="text-center mx-400">
                                            <b-button :loading="add_new_card_load" @click="add_new_card_func()" type="is-primary" class="w-100"><i class="fas fa-credit-card"></i> {{get_local_string.string_35}}</b-button>
                                        </div>
                            </div>
                        </div>
                        <!-- end  -->
                         <!-- add new cart sumup -->
                        <div id="modal-add-card-sumup" uk-modal="stack:true">
                            <div class="uk-modal-dialog uk-modal-body">
                                <button class="uk-modal-close-default" type="button" uk-close></button>
                                <h2 class="uk-modal-title">{{get_local_string.string_34}}</h2>
                                        <!-- :trans="translations" -->
                                        <v-credit-card @change="creditInfoChanged" ref="vcard"  />
                                        <div class="text-center mx-400">
                                            <b-button :loading="add_new_card_load" @click="add_new_card_func_sumup()" type="is-primary" class="w-100"><i class="fas fa-credit-card"></i> {{get_local_string.string_35}}</b-button>
                                        </div>
                            </div>
                        </div>
                        <!-- end  -->
                </div>
           <googlePlacescomp></googlePlacescomp>
            </div>
            </template>
        </div>
    </div>
</template>
<script>
 import $ from 'jquery';
//  import store from '../../store/store.js'
import googlePlacescomp from '@/components/global/googleplaces.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
const translations = {
    name: {
        label: 'Nombre',
        placeholder: 'Nombre completo'
    },
    card: {
        label: 'Número de tarjeta',
        placeholder: 'Número de tarjeta'
    },
    expiration: {
        label: 'Expiration'
    },
    security: {
        label: 'Código de seguridad',
        placeholder: 'Código'
    }
};
export default {
   name:'cartApp',
   components:{googlePlacescomp},
    data(){
        return{
            local_min_price_address:0,
            total_price:0,
            local_qty:0,
            levering_method:null,
            errorMsg:'',
            radio_address:null,
            plus_price_delevery:0,
            activeTab:0,
            default_clock:{
                date:'',
                time:'',
                day:'',
                full:'',
            },
            pre_full_date:'',
            order_details:{
            auth_token:'',
            platform:'web',
            note:'',
            admin_order_date:''
            },
            active_alert_wraning : false,
            payemnt_load_1:false,
            payemnt_load_2:false,
            payemnt_load_3:false,
            payemnt_load_4:false,
            add_new_card_load:false,
            delete_stripe_card_load:false,
            delete_sumup_card_load:false,
            delete_card_index:undefined,
            labelPosition: 'on-border',
            cart_info_obj:{},
            translations,
            stripe_card:undefined,
            sumup_card:undefined,
            random_bg:1,
            checkout_stripe:true,
            checkout_sumup:true,
            stripe_load:false,
            sumup_load:false,
            disabled_pay_button:false,
             couopn_input:'',
        }
       
    },
    computed:{
        ...mapGetters({
            get_data_cart:'get_data_cart',
            all_data_cart:'all_data_cart',
            get_count_cart:'get_count_cart',
            get_grand_total:'get_grand_total',
            get_sub_total:'get_sub_total',
            get_setting_app:'get_setting_app',
            get_levering_status:'get_levering_status',
            user:'auth/user',
            login_token_cart:'auth/login_token_cart',
            getDayPre:'getDayPre',
            get_cash_res:'get_cash_res',
            // 
            get_vipps_res:'get_vipps_res',
            get_add_cart_res:'get_add_cart_res',
            get_stripe_card_list:'get_stripe_card_list',
            get_stripe_res:'get_stripe_res',
            // sumup
            get_sumup_card_list:'get_sumup_card_list',
            get_sumup_res:'get_sumup_res',
              // 
            get_local_string:'get_local_string',
            get_before_dicount:'get_before_dicount',
             get_coupon_object:'get_coupon_object',
             get_final_item_total:'get_final_item_total'
            
        }),
    },
    methods:{
        ...mapActions({
            get_data_cartAction:'get_data_cartAction',
            update_data_cart:'update_data_cart',
            delete_data_cart:'delete_data_cart',
            delevery_levering:'delevery_levering',
            remove_address:'remove_address',
            select_day:'select_day',
            create_order:'create_order',
            pay_cash_method:'pay_cash_method',
            pay_vipps_method:'pay_vipps_method',
            add_new_card:'add_new_card',
            stripe_card_list:'stripe_card_list',
            remove_card_stripe:'remove_card_stripe',
            pay_stripe_method:'pay_stripe_method',
            // sumup
            sumup_card_list:'sumup_card_list',
            pay_sumup_method:'pay_sumup_method',
            remove_card_sumup:'remove_card_sumup',
            add_new_card_sumup:'add_new_card_sumup',
            // 
            apply_coupon_code_api:'apply_coupon_code_api',
            remove_coupon_code_api:'remove_coupon_code_api'
        }),
        ...mapMutations({
            SET_GRAND_TOTAL:'SET_GRAND_TOTAL',
            SET_CART_COUNT :'SET_CART_COUNT'
        }),
        show_option(event){
            event.target.classList.toggle('modify');
        } ,show_option2(event){
             if(event.srcElement.parentNode.classList.contains('modify'))
             {
                  event.srcElement.parentNode.classList.remove('modify')
             }
             else{
                 event.srcElement.parentNode.classList.add('modify')
             }
        },
        updateItem(item , event){
            let item_updete = {
             item_id : item.item_id , 
             item_qty: event.target.value
            }
             this.total_price = 0;
             this.local_qty = 0;
             
            //  ########
               document.querySelectorAll('.move_left_cart').forEach((elem)=>{
               this.total_price += (parseFloat( elem.getAttribute('price_data')) * parseFloat(elem.getAttribute('qty')));
               this.local_qty += parseInt(elem.getAttribute('qty'));
          })
            // call animation count 
            // this.animaion_count(this.total_price);
            // end
             this.SET_GRAND_TOTAL(parseFloat(this.total_price));
             this.SET_CART_COUNT(this.local_qty);
            //#####
            // end animation 
            this.update_data_cart(item_updete).then(()=>{
                console.log(this.local_min_price_address , this.get_sub_total , 'radio_address');
            if(this.local_min_price_address > this.get_sub_total){
                console.log('get take');
                this.get_takeaway();
            }
            });
            event.path[5].classList.toggle('modify');
        },

        delteItem(item,index){
            let item_updete = {
             item_id : item.item_id
            }
        $(`#del-${index}`).parents('.move_left_cart').toggleClass('modify');
        $(`#del-${index}`).parents('.single_side').fadeOut();
            this.delete_data_cart(item_updete).then(()=>{
                if(this.local_min_price_address > this.get_sub_total){
                console.log('get take');
                this.get_takeaway();
            }
            });
            this.total_price = this.get_sub_total - item.item_total;
            // this.animaion_count(this.total_price);
        },
        fetchData_local() {
            this.total_price = this.get_sub_total;
        },
        // step 2 levering
        get_takeaway(){
        $('.myaddressRadio').removeClass('checkedRadio');
        $(`.option_levering`).removeClass('selected_mehods');
        $(`.takeaway`).addClass('selected_mehods');
         $('.is_choose_delvery').fadeOut();
         $('.plus_devery_price').fadeOut();
          this.plus_price_delevery = 0;
         this.radio_address = '';
        let levering_obj = {
        'delivery_method' :'takeaway' , 
        'delivery_address':0
        }
        this.delevery_levering(levering_obj).then(()=>{
           if(this.get_levering_status.status == 200){
                 this.disabled_pay_button=false;
               this.errorMsg=`<b>${this.get_levering_status.message}</b>`;
                this.success();
               
           }
        });

        },
         get_delevery(){
             $(`.option_levering`).removeClass('selected_mehods');
             $(`.delevery`).addClass('selected_mehods');
             $('.is_choose_delvery').fadeIn();
             $('.plus_devery_price').fadeIn();
             if(this.radio_address=='')
              {
                  this.disabled_pay_button=true;
              }
              else{
                  this.disabled_pay_button=false;
              }
             
        },
        removeAddress(address_id){
            if(this.radio_address == address_id)
            {
                // if address remove the same address is selected
                this.radio_address = '';
                 this.address_list_is_empty();

            }
            this.remove_address(address_id).then(()=>{
                this.errorMsg = 'Address removed successfully';
                this.danger();
                this.address_list_is_empty();
            });
           
        },
        chnageAddress(address_id , address_price , min_price_address){
             $('.myaddressRadio').removeClass('checkedRadio');
            $('#id-'+address_id).addClass('checkedRadio');
            this.local_min_price_address = min_price_address;
            console.log(this.local_min_price_address , 'omar1');
            this.plus_price_delevery = address_price;
            let levering_obj = {
        'delivery_method' :'delivery' , 
        'delivery_address':address_id
        }
        this.delevery_levering(levering_obj).then((res=>{
           console.log(this.get_levering_status , res ,'reslabel')
           if(this.get_levering_status.status == 200){
            //    set radio address value on change 
               this.radio_address = address_id;
             //  after that call is empty address func to check disabled pay btn
             this.address_list_is_empty()
            //    
               this.errorMsg=`<b>${this.get_levering_status.message}</b>`;
                this.success();
           }
        }));
        },
        show_modal_map(){
        this.uk.modal($('#modal-container')).show();
        },
        openModal_hour(){
        //   $('#modal-dates .uk-modal-dialog').removeClass('uk-animation-reverse');
        //         $('#modal-dates').addClass('uk-animation-slide-bottom')
                this.uk.modal($('#modal-dates')).show();
        },
        changeTabFunc(tabselected){
            if(tabselected == 0){
                this.activeTab= 0;
                this.pre_full_date  = '';
            }
            else if(tabselected==1)
            {
                this.activeTab= 1;
                this.openModal_hour();
                 $(`.flex_hour a`).removeClass('active');
                // this.pre_full_date = this.default_clock.full;
            }
        },
          check_default_date_api_status(){
           
            if(this.all_data_cart.defult_time==true){
                this.activeTab= 0;
                this.pre_full_date  = '';
            }
            else if(this.all_data_cart.defult_time==null)
            {
                this.pre_full_date  = '';
            }
            else{
                this.activeTab= 1;
                this.default_clock.date = this.all_data_cart.defult_time.date;
                this.default_clock.time = this.all_data_cart.defult_time.time;
                this.default_clock.day = this.all_data_cart.defult_time.day;
                this.default_clock.full = this.all_data_cart.defult_time.full;
            //    
                this.pre_full_date  = this.all_data_cart.defult_time.full;
            // 
            this.active_alert_wraning = true;
                
            }
        }
        ,
        get_date_click(date_clicked,index){
            $(".flex_hour a").hide();
            $(".flex_hour a").slice(0, 20).show();
            $(".load-more").css('visibility', 'visible');
            $(`.single_date`).removeClass('active');
            $(`#date_${index}`).addClass('active');
            $(`.flex_hour a`).removeClass('active');
            $(`#hour_0`).addClass('active');
            this.get_pre_days(date_clicked.full)
        },
        get_hour_click(hour_clicked , index){
            $(`.flex_hour a`).removeClass('active');
            $(`#hour_${index}`).addClass('active');
             $('#modal-dates .uk-modal-dialog').addClass('uk-animation-slide-bottom uk-animation-reverse');
              setTimeout(()=>{
                  this.uk.modal($('#modal-dates')).hide();
              },250)
              $('#modal-dates .uk-modal-dialog').removeClass('uk-animation-slide-bottom uk-animation-reverse');
              this.default_clock.date = hour_clicked.date;
              this.default_clock.time = hour_clicked.time;
              this.default_clock.day = hour_clicked.day;
              this.default_clock.full = hour_clicked.full;
              
            //   var go to create order
              this.pre_full_date  = hour_clicked.full;
        },
        show_more_hour(){
            $(".flex_hour a:hidden").slice(0, 20).show();
			if ($(".flex_hour a:hidden").length == 0) {
				$(".load-more").css('visibility', 'hidden');
			}
        },
        get_pre_days(today){
            this.select_day(today).then(()=>{
                // console.log('length days' , this.all_data_cart.date_list.length)
                if(Object.keys(this.getDayPre).length>0)
                {
                     $(".flex_hour a").slice(0, 20).show();
            // 
                 this.default_clock.date = this.getDayPre[0].date;
                 this.default_clock.time = this.getDayPre[0].time;
                 this.default_clock.day = this.getDayPre[0].day;
                 this.default_clock.full = this.getDayPre[0].full;
                //  var go create order
                //  this.pre_full_date  = ''; 
                //  this.order_details = this.get_pre_days[0].full;
                }
            })
           
        },
       pay_cash(){
           this.payemnt_load_1 = true;
        //    set token
         this.order_details.auth_token = this.login_token_cart.token;
        //  set full date order
         this.order_details.admin_order_date = this.pre_full_date; 
         this.create_order(this.order_details).then(()=>{
            // pay cash now 
            this.pay_cash_method().then(()=>{
                 this.payemnt_load_1 = false;
                  this.SET_GRAND_TOTAL(0);
                  this.SET_CART_COUNT(0);
                //   go to done
                   this.$router.replace('/done-order');
            });
         });
           
       },
       pay_vipps(){
             this.payemnt_load_2 = true;
        //    set token
         this.order_details.auth_token = this.login_token_cart.token;
        //  set full date order
         this.order_details.admin_order_date = this.pre_full_date; 
         this.create_order(this.order_details).then(()=>{
            // pay vipps now 
           this.pay_vipps_method().then(()=>{
                 this.payemnt_load_2 = false;
                 window.location.href = `${this.get_vipps_res.url}`;
            });
         });
           
       },
       creditInfoChanged(values) {
           this.cart_info_obj = values;
            // console.log('Credit card fields', values); 
        },
        open_modal_add_card(){
            this.uk.modal($('#modal-add-card')).show();
        },
         open_modal_add_card_sumup(){
            this.uk.modal($('#modal-add-card-sumup')).show();
        },
        pay_stripe(){
           //    set token
        this.stripe_load=true;
         this.order_details.auth_token = this.login_token_cart.token;
        //  set full date order
         this.order_details.admin_order_date = this.pre_full_date; 
            this.create_order(this.order_details).then(()=>{
            // pay stripe now 
            console.log('on call pay stripe', this.stripe_card);
           this.pay_stripe_method(this.stripe_card).then(()=>{
            this.uk.modal($('#modal-stripe')).hide();
             this.stripe_load=false;
             this.errorMsg=`<b>Payment Stripe successfully</b>`;
              this.success();
               this.$router.replace('/done-order');
            });
         });

        },
         pay_sumup(){
           //    set token
        this.sumup_load=true;
         this.order_details.auth_token = this.login_token_cart.token;
        //  set full date order
         this.order_details.admin_order_date = this.pre_full_date; 
            this.create_order(this.order_details).then(()=>{
            // pay sumup now 
           this.pay_sumup_method(this.sumup_card).then(()=>{
            this.uk.modal($('#modal-sumup')).hide();
             this.sumup_load=false;
             this.errorMsg=`<b>Payment Sumup successfully</b>`;
              this.success();
               this.$router.replace('/done-order');
            });
         });

        },
        
       open_modal_stripe(){
            this.random_bg = Math.floor(Math.random() * 10)+ 1;;
            this.stripe_card_list();
            this.uk.modal($('#modal-stripe')).show();
       },
       open_modal_sumup(){
        this.random_bg = Math.floor(Math.random() * 10)+ 1;;
            this.sumup_card_list();
            this.uk.modal($('#modal-sumup')).show();
       },
       changecard_stripe(card_id){
            if(this.stripe_card === undefined)
           {
                this.checkout_stripe=true;

           }
           else{
        this.checkout_stripe=false;
           }
           console.log(card_id,'card id');
       },
         changecard_sumup(card_id){
            if(this.sumup_card === undefined)
           {
                this.checkout_sumup=true;

           }
           else{
                this.checkout_sumup=false;
           }
           console.log(card_id,'card id');
       },
      
       add_new_card_func(){
           this.add_new_card_load= true;
           let card_info_val ={
               exp_date: this.cart_info_obj.expiration,
               number: this.cart_info_obj.cardNumber,
               cvc: this.cart_info_obj.security,
               name: this.cart_info_obj.name,
           }
          this.add_new_card(card_info_val).then(()=>{
               this.errorMsg=`<b>Added New Card successfully</b>`;
               if(this.get_add_cart_res==200)
               {
                this.success();
                this.add_new_card_load= false;
                 this.uk.modal($('#modal-add-card')).hide();
               
            //    reset component value vcard
                     document.getElementById('name').value='';
                       document.getElementById('card-number').value='';
                      document.getElementById('expirationdate').value='';
                         document.getElementById('securitycode').value='';
                       this.$refs.vcard.resetCardDefaults();
                          let emptys ={
                        expiration:'',
                        cardNumber:'',
                        security:'',
                        name:'',
                                  }
                          Object.assign(this.$refs.vcard.form, emptys);
                        document.querySelector('.creditcard').classList.remove('flipped');
          
               }
               else{
               this.errorMsg=`<b>Wrong Card , Please Try Again !</b>`;
               this.danger();
               this.add_new_card_load= false;
               }
                
          })
       },
        add_new_card_func_sumup(){
           this.add_new_card_load= true;
           let card_info_val ={
               exp_date: this.cart_info_obj.expiration,
               number: this.cart_info_obj.cardNumber,
               cvc: this.cart_info_obj.security,
               name: this.cart_info_obj.name,
           }
            // set token 
            this.order_details.auth_token = this.login_token_cart.token;
           //  set full date order
         this.order_details.admin_order_date = this.pre_full_date; 
            //  console.log(this.order_details , 'from sumup pay');
            this.create_order(this.order_details).then(()=>{
            this.add_new_card_sumup(card_info_val).then(()=>{
               this.errorMsg=`<b>Added New Card successfully</b>`;
            //    console.log(this.get_add_cart_res.data.url , 'response sumup 2022');
               if(this.get_add_cart_res.status==200)
               {
                 window.location.href = `${this.get_add_cart_res.data.url}`;
                this.success();
                this.add_new_card_load= false;
                 this.uk.modal($('#modal-add-card-sumup')).hide();
                

            //    reset component value vcard
                     document.getElementById('name').value='';
                       document.getElementById('card-number').value='';
                      document.getElementById('expirationdate').value='';
                         document.getElementById('securitycode').value='';
                       this.$refs.vcard.resetCardDefaults();
                          let emptys ={
                        expiration:'',
                        cardNumber:'',
                        security:'',
                        name:'',
                                  }
                          Object.assign(this.$refs.vcard.form, emptys);
                        document.querySelector('.creditcard').classList.remove('flipped');
          
               }
               else{
               this.errorMsg=`<b>Wrong Card , Please Try Again !</b>`;
               this.danger();
               this.add_new_card_load= false;
               }
                
          })
            });
       },
       remove_stripe_card(card_id,index){
           this.delete_card_index= index;
           this.delete_stripe_card_load=true;
           this.remove_card_stripe(card_id).then(()=>{
                this.errorMsg = 'Card removed successfully';
                this.danger();
                 this.delete_stripe_card_load=false;
           })
        
       },
       remove_sumup_card(card_id,index){
           this.delete_card_index= index;
           this.delete_sumup_card_load=true;
           this.remove_card_sumup(card_id).then(()=>{
                this.errorMsg = 'Card removed successfully';
                this.danger();
                 this.delete_sumup_card_load=false;
           })
        
       },
          // MSG ALERT
        success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
    //   if user delete all address list and api selected delvery method then => change from delevery        to takeaway
      address_list_is_empty(){
        //   this.all_data_cart.data.delivery_method=='delevery') &&
          if( (this.user.addressList.length==0) ){
                // console.log('now  is empty');
                this.radio_address = '';
                // if delete all address and open takeway is open from setting select takeaway default
                if(this.get_setting_app.delivery.open_takeaway==1)
                {
                     this.get_takeaway();
                     this.disabled_pay_button=false;
                }
                else{
                      this.plus_price_delevery = 0;
                    //   and all pay button disbled because no address 
                    this.disabled_pay_button=true;
                }
          }
          else{
              if(this.radio_address=='')
              {
                  if(this.get_setting_app.delivery.open_takeaway==1)
                  {
                    //   have address and not select any address and takeaway is open so select takeaway
                     this.get_takeaway();
                     this.disabled_pay_button=false;
                  }else{
                      this.disabled_pay_button=true;
                  }
                  
              }else{
                   this.disabled_pay_button=false;
              }
          }
      },
      default_local(){
      //  console.log(this.user.addressList[0].id, 'default local');
       if(this.all_data_cart.data.delivery_method=='delevery'){
           this.get_delevery();
           this.radio_address= this.all_data_cart.data.address;
        //    
            this.plus_price_delevery = this.all_data_cart.data.delivery_price;
            let levering_obj = {
        'delivery_method' :'delivery' , 
        'delivery_address':this.all_data_cart.data.address
        }
        this.delevery_levering(levering_obj);
        // 
       }
       else{
        $(`.option_levering`).removeClass('selected_mehods');
        $(`.takeaway`).addClass('selected_mehods');
         $('.is_choose_delvery').fadeOut();
         $('.plus_devery_price').fadeOut();
          this.plus_price_delevery = 0;
         this.radio_address = '';
        let levering_obj = {
        'delivery_method' :'takeaway' , 
        'delivery_address':0
        }
        this.delevery_levering(levering_obj);
       }
     },
    apply_coupon_code(){
           console.log(this.couopn_input , 'coupon Input');
           this.apply_coupon_code_api(this.couopn_input).then(res=>{
               console.log(res , 'response apply api');
               if(res.status!=200){
                   this.errorMsg = res.message;
                   this.danger();
               }
               else if(res.status==200){
                   this.uk.modal($('#discount')).show();
                   console.log(res.data.code , 'res data code')
                    this.couopn_input = res.data.code;
               }
               
              
            //    console.log('after fill ',  this.couopn_input , 'and' , this.get_coupon_object.code );
           });
       },
        remove_coupon_code(){
           console.log( 'remove coed Input');
           this.apply_coupon_code_api().then(res=>{
               this.couopn_input = '';
               $('.input_code input').attr("placeholder",' Coupon Code ..');
               console.log(res , 'response remove api');
           });
       },
    },
    
    mounted(){
          this.get_data_cartAction().then(()=>{
               this.uk.offcanvas($('#offcanvas-flip')).hide();
          this.default_local();
         this.fetchData_local();
         this.get_pre_days();
            this.check_default_date_api_status();
             this.address_list_is_empty();
              if(this.get_coupon_object.is_apply==1){
                 this.couopn_input = this.get_coupon_object.code;
             }
            
        });
        
    },
}
</script>

<style lang="scss">
.uk-alert {
    position: relative;
    margin-bottom: 20px;
    padding: 15px 29px 15px 15px;
    background: #e6e6e6 !important;
    color: #666;
}
.remove_code{
    ion-icon{
    font-size: 22px;
    padding-top: 6px;
    }
}
.input_code
{
input:disabled{
    background-color: #e7e6e6 !important;
}
}
.CartClass{
#discount {
    a{
        display: none !important;
    }
}
}

.del_dis{
    color: #363636;
    strong{
        color: #363636;
    }
}
.col_warning_class{
    .dis_wrap{
        margin-top: 15px !important;
    }
}
.dis_wrap{
    margin-top: 66px !important;
    .has-icons-left{
        flex: 0 0 calc(100% - 70px);
    }
}
.span_dis{
    font-size: 14px;
    color: #f14667;
    padding-left: 8px;
    font-weight: 500;
    transition: 0.2s ease-in-out;
}
.total_price{
    font-size: 18px;
   strong{
        padding-right: 10px;
   }
}
@media(max-width:767px){
    .text_panel {
    font-size: 14px !important;
}
}
// 
.col_warning_class{
    .box_pay{
        margin-top: 0px !important;
    }
    .notification.is-warning{
        margin-top: 66px;
        margin-bottom: 14px !important;
    }
      .media-content{
            font-size: 14px;
        }
}
.tabs li.is-active a{
   color: var(--active_color) !important;
    border-bottom-color: var(--active_color) !important;
}
.tabs a:hover{
    border-bottom-color: var(--active_color2) !important;
    transition: 0.2s linear;
}
.textarea{
  background-color: #f5f5f5 !important;
    color: #363636 !important;
    font-size: 14px;
}
.field.is-floating-label .label {
    color: white !important;
}
.field.is-floating-label .label {
    color: #363636 !important;
}
.field.is-floating-label .label:before {
    background-color: #f5f5f5 !important;
    color: white;
}
 .textarea:focus, .is-focused.textarea, .textarea:active, .is-active.textarea{
    border-color: var(--active_color) !important;
}
.stripe{
    background-color: #6772e4 !important;
    color: white !important;
     border: none !important;
    width: 100%;
    height: 44px;
    margin-top: 16px;
    border-radius: 4px;
    transition: 0.2s linear;
    span{
          display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 17px;
    }
    i{
        font-size: 29px;
        margin-left: 12px;
    }
    &:hover{
        color: white;
        background-color: #5360f3 !important;
    }

}
.sumup{
    background-color: #009688 !important;
    color: white !important;
     border: none !important;
    width: 100%;
    height: 44px;
    margin-top: 16px;
    border-radius: 4px;
    transition: 0.2s linear;
    span{
          display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 17px;
    }
    i{
        font-size: 29px;
        margin-left: 12px;
    }
    img{
        width: 80px;
        object-fit: contain;
        margin-left: 15px;
    }
    &:hover{
        color: white;
        background-color: #027468 !important;
    }

}
.uk-modal{
    z-index: 10 !important;
}
#modal-stripe , #modal-sumup{
    
.b-radio{
    width: auto;
    position: relative;
}
  .control-label{
       width: 370px;
    }
    .field .removeCard {
    position: absolute;
    right: -18px;
    top: 30px;
    border-radius: 100% !important;
    width: 30px;
    height: 30px;
    z-index: 2;
    }
    .field{
        text-align: center;
    }
    .add_card_wrap{
        span.check{
            visibility: hidden;
        }
    }
}

</style>
<style lang="scss" scoped>
.change_span_time{
    font-size: 15px;
    font-weight: 500;
}
.colsed_wrap{
    text-align: center;
    img{
       width: auto;
    }
}
.check_out_sticky{
    height: 70px;
    display: flex;
    align-items: center;
    background-color: #7956d5;
    opacity: 0.9;
    position: sticky;
    bottom: -50px;
    font-weight: 600;
   transition: opacity 0.15s linear;
    i{
        font-size: 22px;
        vertical-align: middle;
    }
    &:hover{
        opacity: 1;
    }
}
.mx-400{
 max-width: 360px;
 margin: 0 auto;
}
#modal-stripe , #modal-add-card{
    h2{
        color: #6772e4;
        font-weight: 600;
    }
    .uk-modal-dialog{
           background-color: #0b1518;
        border: 1px solid #3839399c;
        border-radius: 10px;
        }
}
#modal-sumup{
 h2{
        color: #009688;
        font-weight: 600;
    }
    .uk-modal-dialog{
           background-color: #0b1518;
        border: 1px solid #3839399c;
        border-radius: 10px;
        }   
}
.card_front{
        max-width: 370px;
    min-height: 205px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 2;
    margin-top: 40px;
    text-align: left;
}
.card_view{
     width: 100%;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 20px 60px 0 rgb(14 42 90 / 55%);
    transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
    transform-style: preserve-3d;
    transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    backface-visibility: hidden;
     min-height: 205px;
     height: 205px;
}
.card-item__bg {
    max-width: 100%;
    display: block;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
}
.card-item__cover {
    height: 100%;
    background-color: #1c1d27;
    position: absolute;
    height: 100%;
    background-color: #1c1d27;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
}
.card-item__cover:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(6, 2, 29, 0.45);
}
.card-item__typeImg {
    max-width: 100%;
    object-fit: contain;
    max-height: 100%;
    object-position: top right;
    width: 80px;
}
.card-item__chip {
    width: 60px;
}
.card-item__top {
  display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 15px;
    padding: 20px 15px;
}
.card-item__number {
font-weight: 600;
    line-height: 1;
    color: #fff;
    font-size: 20px;
    margin-bottom: 0px;
    display: flex;
    padding: 10px 15px;
    cursor: pointer;
    justify-content: space-around;
    align-items: center;
}
.card-item__content {
    color: #fff;
    display: flex;
    align-items: flex-start;
}
.card-item__info {
    color: #fff;
    width: 100%;
    max-width: calc(100% - 100px);
    padding: 10px 15px;
    font-weight: 500;
    display: block;
     font-size: 14px;
    cursor: pointer;
}
.card-item__date {
    flex-wrap: wrap;
    font-size: 14px;
    margin-left: auto;
    padding: 10px;
    display: inline-flex;
    width: 100px;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;
}
// .uk-modal-dialog{
//     iframe{
//     width: 100%;
//     height: 600px;
//     }
// }

test fra Amer ikke laga mat 

.nar_span{
    color: var(--active_color);
    font-size: 14px;
    margin-left: 8px;
}
.cart_empty{
    text-align: center;
    padding-top: 60px;
    img{
        width: 500px;
    }
    a{
        font-weight: 600;
    }
    p{
        text-transform: capitalize;
        margin-top: 28px;
        margin-bottom: 20px;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
    }
}
.b-btn-load{
    width: 100%;
    margin-top: 14px;
}
.payemnt_btn{
    font-weight: 600;
    img{
    width: 44px;
    height: 40px;
    object-fit: contain;
    filter: invert(1);
    }
}
.sub_title{
   font-size: 15px;
    color: #888888;
    font-weight: 500;
    padding-left: 7px;
    margin: 10px 0px;
}
.asap{
    font-size: 15px;
    font-weight: 600;
    color: black;
}
// .empty_date{
//     padding-top: 15px;
//     padding-bottom: 8px;
// }
.icons_edit_date{
    font-size: 50px;
    color: #5b5e60;
}
.sm_wrapp{
    display: flex;
    align-items: center;
     cursor: pointer;
}
.selected_pre_date{
    cursor: pointer;
        display: flex;
    align-items: center;
    color: black;
    justify-content: space-between;
    .left_date{
        display: flex;
    flex-direction: column;
    margin-right: 20px;
    font-size: 16px;
    font-weight: 500;
    }
    .day_text{
    font-weight: 600;
    color: black;
    }
    .day_date{
        color: var(--active_color);
    }
    .right_date{
    font-size: 45px;
    font-weight: 500;
    }
}
#modal-dates .uk-modal-dialog{
    max-width: 800px;
    width: 800px;
    background-color: #1c0a00c4;
}
.felx_dates , .flex_hour{
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
    margin-left: 0.313rem;
    margin-right: -2.5rem;
    .single_date{
    // margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #6c6c6c;
    border-radius: 4px;
    padding: 4px 10px;
    }
    a.active{
    background-color: #000000;
    font-weight: 700;
    border: 1px solid #fff;
    }
    a{
        width: 12.5%;
        margin-right: 0.625rem;
        margin-bottom: 10px;
        color:#fff;
        transition: 0.2s ease-in-out;
    }
}
  .flex_hour{
    //   margin-top: 10px;
      a.active{
    background-color: #000000;
    font-weight: 700;
    border: 1px solid #fff;
      }
        a{
    border: 1px solid #6c6c6c;
    border-radius: 4px;
    padding: 4px 10px;
    margin-bottom: 15px;
    text-align: center;
      transition: 0.2s ease-in-out;
      display: none;
        }
    }
.dates_title{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
      color:#fff;
      padding-left: 7px;
}
.flex_tooltip{
        display: flex;
    flex-direction: column;
    justify-content: center;
    width: 170px !important;
    align-items: baseline;
}
.b-tooltip.is-multiline.is-medium .tooltip-content{
    width: 170px !important;
}
.grand_total_with_delevery{
    font-weight: 700;
    color: var(--active_color);
}
.is_choose_delvery , .plus_devery_price{
    display: none;
}
.plus_devery_price{
    color: var(--active_color);
}
.field{
    position: relative;
.removeAddress{
   position: absolute;
    right: -8px;
    top: -8px;
    border-radius: 100% !important;
    width: 30px;
    height: 30px;
}
}
.noAddress_wrap{
  text-align: center;
  padding-bottom: 20px;
  img{
    width: 350px;
    object-fit: contain;
  }
  p{
        font-size: 15px;
    font-weight: 500;
    margin-top: 20px;
  }
}
.address_list{
    padding: 0px 20px 40px 20px;
    .b-radio .control-label {
    margin-top: -1px !important;
        }
    .b-radio{
    border: 1px solid #5b5e603a;
    background-color: white;
    color: black;
    padding: 20px 14px;
    border-radius: 4px;
    margin-bottom: 10px;
    font-size: 13px;
    width: 100%;
    padding-right: 30px;
    align-items: flex-start;
    // &:hover{
    //     color: black;
    //     border: 1px solid var(--active_color2);
    // }
   
    }
    .distance{
    margin: 0px 10px;
    font-weight: 800;
    }
    .adress_price{
    display: block;
    font-weight: 800;
    color: var(--active_color);
    font-size: 15px;
    }
    .note{
    margin-top: 4px;
    display: block;
    color: #f14667;
    font-weight: 500;
    font-size: 12px;
    bottom: 10px;
    position: absolute;
    }
}

.flex_list_add{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
}
.addbtnaddress{
    font-weight: 700;
}
 .newIcons{
  font-size: 13px !important;
    margin-right: 4px;
        }
.address_title{
    color: var(--active_color);
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
}
.flex_delevey{
    display: flex;
    justify-content: space-between;
    padding: 20px 14px;
    align-items: center;
      .option_levering.selected_mehods{
        //   pointer-events: none;
         border: 1px solid #fff;
             background-color: var(--active_color);
        .levering_title{
                color: #fff;
        }
        img{
                 opacity: 1;
            }
    }
    .option_levering{
           text-align: center;
            flex: 0 0 40%;
            background-color: #bcbcbc;
            border: 1px solid #fff;
            padding: 18px 0px;
            border-radius: 4px;
             transition: 0.3s linear;
            cursor: pointer;
        .levering_title{
               display: block;
                font-size: 18px;
                margin-top: 10px;
                font-weight: 600;
                color: #fff;
                 transition: 0.15s linear;
        }
        img{
                // filter: invert(1);
                 width: 110px;
                 opacity: 0.5;
                  transition: opacity 0.15s linear;
            }
        label{
            display: none;
        }
    }
}




/* Title Page  */
.title_page{
    margin-top: 210px;
}
.title_page h2{
    font-size: 32px;
    display: block;
    margin-bottom: 0px;
    }
.title_category{
   text-align: center;
}
.title_page span{
    font-size: 20px;
    display: block;
}
/* End Title Page  */

/* cart wrap  */
.cart_wrap{
    padding-top: 50px;
    padding-bottom: 20px;
}
.panelBg{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    color: #363636
}
.uk-accordion-title{
    padding: 16px 14px;
    background-color: #1c0a00c4;
     color: #363636;
    transition: 0.3s all;
    border: 1px solid #1c0a00c4;
    /* border-radius: 4px; */
}
.uk-accordion-title:hover {
    /* background-color: #232323c8;
    border: 1px solid #f5f5f5c8; */
    color: black;
}
.uk-accordion-title:focus{
    background-color: #1c0a00c4;
    border: 1px solid #1c0a00c4;
    color: black;
}
.uk-accordion-title::before {
    font-family: "Font Awesome 5 Free"; 
    font-weight: 900; 
    content: "\f078";
    width: unset;
    height: unset;
    float: right;
    background-image: none;
    transition: all 0.5s;
}
.uk-open>.uk-accordion-title::before {
  -webkit-transform: rotate(180deg);
	-moz-transform: rotate(180deg);
	transform: rotate(180deg);
background-image: none;
}
.uk-accordion-content {
    display: flow-root;
    /* padding: 20px; */
    background-color: #e6e6e6;
    color: rgb(185, 185, 185);
    font-size: 14px;
    margin-top: 0px;
}
.text_panel_up h2{
    font-size: 22px;
    padding-top: 18px;
    color: black;
    margin-bottom: 20px;
    font-weight: 500;
}
.total_price , .change_span_time{
    color: var(--active_color);
}
.text_panel{
    font-size: 18px;
}
.total_price{
    font-size: 18px;
}
.text_panel i {
    margin-right: 6px;
}
/* end cart wrap */
/* prod cart */
.uk-accordion-content .item_product_info
{
    width: 100%;
    display: flex;
    align-items: center;
     background-color:transparent;
    flex: 0 0 100%;
    justify-content: space-around;
    align-items: center;
    padding: 10px 10px;
    border: 1px solid #5a5a5a;
    position: relative;
}
.uk-accordion-content .select_card{
    background-color: black;
}
.uk-accordion-content .flex_counter_card .minus_c, .uk-accordion-content .flex_counter_card .plus_c {
background-color: black;
border: 1px solid rgb(255 255 255);
}
.uk-accordion-content .flex_counter_card .minus_c:hover, .uk-accordion-content .flex_counter_card .plus_c:hover{
    background-color: var(--main_color);
}
.uk-accordion-content .no_item {
    font-size: 18px;
    font-weight: 800;
    text-align: center;
    width: 24px;
    border: none;
    color: rgb(255 255 255);
    background: black;
}
.uk-accordion-content .flex_counter_card i {
    color: rgb(255 255 255);
}

/* end */

/* box_pays */
.b-tabs .tab-content{
    color: black !important;
}
.box_pay{
    background-color: #e6e6e6 !important;
    color: black;
    padding: 40px 20px 50px 20px;
    font-size: 14px;
    text-align: center;
    position: sticky;
    top: 100px;
    margin-top: 0px;
}
.title_Pay_up{
    font-size: 14px;
}
.price_will_payed{
    font-size: 21px;
    margin-top: 22px;
  
}
.secure_pay{
    font-size: 12px;
    margin-top: 10px;
}
.secure_pay i{
    margin-right: 5px;
}
.payement_links .vipps{
background-image: url('../../assets/betalt_vipps.svg');
background-position: 50%;
    background-repeat: no-repeat;
    background-color: #ff5b24;
    color: transparent;
    border: none;
    width: 100%;
    height: 44px;
    margin-top: 16px;
    border-radius: 4px;
}

/* end box */
.payement_links a{
    height: 44px;
    width: 100%;
    margin-top: 24px;
    display: block;
    border-radius: 4px;
}
.shopping_more{
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: #5b5e60;
    // color: white;
    border-radius: 5px;
}
.remove_cart{
    height: 44px;
    display: inline-block;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    color: rgba(255, 255, 255, 0.784) ;
    border-radius: 5px;
    margin-top: 20px;
}
.remove_cart i{
    margin-right: 4px;
}
.flex_lat_long{
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 25px 0px;
}
.flex_lat_long input{
    background-color: transparent;
    color: white;
    border: 1px solid white;
    border-radius: 4px;
}
.comment {
    margin: 10px auto;
    width: 94%;
    padding-bottom: 20px;
}
.comment textarea{
    height: 90px;
    background-color: transparent;
    color: white;
    border-radius: 4px;
}


.uk_search{
    margin: 10px auto;
    width: 96%;
    padding-bottom: 10px;
}
.tilbetailng{
   background-color: #3f8f4c;
    color: white;
    width: 100%;
    display: flex;
    padding: 14px 10px;
    justify-content: space-between;
    align-content: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 13px;
    strong{
        color: white;
    }
}
.single_side:first-child{
    border-bottom: 0px;
    margin-top: 14px;
}
.move_left.modify{
        transform: translate3d(-4.375rem, 0, 0);
        img{
            opacity: 0;
        }
        .price_side{
            opacity: 0;
        }
        aside{
      -webkit-transform: translate3d(-2.1rem, 0, 0);
    transform: translate3d(-2.1rem, 0, 0);
    opacity: 1;
    z-index: 1;
    pointer-events:auto;
        }
}
.remove_item{
    width: 2.5rem;
    height: 2.5rem;
    margin-left: 0.5rem;
    background-color: #d20a11;
    color: white;
    outline: none;
    border: none;
}

.single_side{
      border-top:1px solid #c7c6c6;
        display: block;
        position: relative;
    .move_left{
   display: flex;
   color: black;
    align-items: center;
    padding: 5px;
    border-width: 0.5px;
    transition: -webkit-transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
        }
        aside{
    position: absolute;
    right: -6.625rem;
    top: 20px;
    opacity: 0;
    transition: -webkit-transform 0.4s cubic-bezier(0.23, 1, 0.32, 1),opacity 0.1s linear;
    transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1),opacity 0.1s linear;
    pointer-events: none;
        }
    img{
        width: 72px;
        height: 72px;
        object-fit: contain;
        transition: opacity 0.15s linear;
    }
    .name_side{
    padding-left: 10px;
    font-size: 12px;
    padding-right: 11px;
   flex: 0 0 calc(100% - 120px);
    }
    .price_side{
        font-weight: 700;
        font-size: 13px;
         transition: opacity 0.15s linear;
    }
}

.checkedRadio{
    .b-radio{
    border: 1px solid var(--active_color) !important;
    background-color: #272727 !important;
    color: white;
    .Kms {
    font-size: 13px;
    color: #fff;
}
.note{
   color: #f14667 !important;
}
}

    
}

</style>